import { PAGE_NAME } from './types'

const INITIAL_STATE = {
  page_name: 'dashboard',
}

const pageNameReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PAGE_NAME:
      return {
        ...state,
        page_name: action.payload,
      }
    default:
      return state
  }
}

export default pageNameReducer
